import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "link_mobile_form_modal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-50" }
const _hoisted_3 = { class: "modal-content rounded" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header justify-content-space-between" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Link Mobile"),
  /*#__PURE__*/_createElementVNode("a", {
    type: "button",
    class: "close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, [
      /*#__PURE__*/_createElementVNode("h1", null, "×")
    ])
  ])
], -1)
const _hoisted_5 = { class: "modal-body d-flex flex-row-fluid flex-center bg-white rounded" }
const _hoisted_6 = {
  key: 0,
  class: "alert alert-primary d-flex align-items-center p-5"
}
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = { class: "column container py-10" }
const _hoisted_10 = ["onSubmit"]
const _hoisted_11 = { class: "d-flex flex-column p-5 pb-0" }
const _hoisted_12 = { class: "d-flex flex-row gap-2 justify-content-center mt-5" }
const _hoisted_13 = ["onClick", "data-kt-indicator"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Verify ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Verifying... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "alert alert-warning d-flex align-items-center p-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "mb-1" }, " Did not receive the validation code of mobile phone? "),
    /*#__PURE__*/_createElementVNode("ol", null, [
      /*#__PURE__*/_createElementVNode("li", null, " There is a delay in the validation code of mobile phone. it may take 2-3 minutes to receive it. Please try again later. "),
      /*#__PURE__*/_createElementVNode("li", null, " If you haven't received it in 2-3 minutes. please check whether your mobile phone service has ceased. or intercepted our message, or the message inbox is full "),
      /*#__PURE__*/_createElementVNode("li", null, " When the phone is lost, disabled or not around, it is recommended that you change other verification methods ")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeField = _resolveComponent("CodeField")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            (_ctx.successMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.successMessage), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Form, {
                "initial-values": _ctx.formData,
                "validation-schema": _ctx.formSchema,
                class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
                ref: "verificationCodeForm"
              }, {
                default: _withCtx(({ handleSubmit, values, validate }) => [
                  _createElementVNode("form", {
                    onSubmit: _withModifiers(($event: any) => (handleSubmit(values, _ctx.submitForm)), ["prevent"])
                  }, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_CodeField, {
                        onInputCode: _ctx.handleCodeInput,
                        formSubmitted: _ctx.formSubmitted
                      }, null, 8, ["onInputCode", "formSubmitted"])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("button", {
                        type: "submit",
                        class: "btn btn-primary align-self-center",
                        onClick: validate,
                        "data-kt-indicator": _ctx.loading ? 'on' : null
                      }, _hoisted_16, 8, _hoisted_13)
                    ])
                  ], 40, _hoisted_10)
                ]),
                _: 1
              }, 8, ["initial-values", "validation-schema"])
            ]),
            _hoisted_17
          ])
        ])
      ])
    ])
  ]))
}